import script from "./News.vue?vue&type=script&setup=true&lang=js"
export * from "./News.vue?vue&type=script&setup=true&lang=js"

import "./News.vue?vue&type=style&index=0&id=647864a0&lang=less"

const __exports__ = script;

export default __exports__